const questions = [
    {
        id: 1,
        question: "What age range are your meals suitable for?",
        answer: "Our meals are suitable for all age groups, from children to seniors. We offer a variety of dishes that cater to diverse dietary needs and preferences."
    },
    {
        id: 2,
        question: "Are your services beginner-friendly for people new to using food delivery apps?",
        answer: "Absolutely! Our food delivery app is designed with user-friendliness in mind, featuring an intuitive interface that makes ordering food easy and convenient for everyone, even those new to using such services."
    },
    {
        id: 3,
        question: "What kind of cuisines and dishes do you offer in your restaurant?",
        answer: "Our restaurant offers a wide range of cuisines, including Indian, Chinese, Italian, and Continental. From hearty main courses to delicious appetizers and desserts, there's something for everyone to enjoy."
    },
    {
        id: 4,
        question: "क्या आपके भोजन वितरण में सभी आवश्यक मसाले और बर्तन शामिल होते हैं?",
        answer: "जी हां, हर भोजन वितरण में सभी आवश्यक मसाले, चम्मच, कांटे और नैपकिन शामिल होते हैं ताकि आपको एक पूर्ण और सुखद भोजन अनुभव मिल सके।"
    },
    {
        id: 5,
        question: "क्या आप आदेशों को व्यक्तिगत पसंद के अनुसार अनुकूलित करने के विकल्प प्रदान करते हैं?",
        answer: "हम आपके व्यक्तिगत स्वाद और पसंद को ध्यान में रखते हुए आदेशों को अनुकूलित करने का विकल्प प्रदान करते हैं। आप अपने आदेश में विशेष निर्देश जोड़ सकते हैं, मसाले की मात्रा बदल सकते हैं या अतिरिक्त टॉपिंग्स की मांग कर सकते हैं।"
    }
];
export {questions};
